import {connect} from 'react-redux';
import ModelView from "../pages/ModelView";

export default connect(
    (state) => ({
        models: state.familyProduct.models
    }),
    (dispatch) => ({
    })
)(ModelView);